import React from 'react';

const ConstructionsSite = () => {
    return (
        <div className="text-center pb-5 mb-5" >
            <h1 className="pt-5 mt-5 text-danger" >This page is  under construction</h1>
            <h1>You can contact with me , i will give you what you want </h1>
        </div>
    );
};
export default ConstructionsSite;